
import { useAddUserMutation } from './useAddUserMutation';
import { useUserStatusMutations } from './useUserStatusMutations';
import { useUserAccountMutations } from './useUserAccountMutations';

export const useUserManagementMutations = () => {
  const addUserMutation = useAddUserMutation();
  const statusMutations = useUserStatusMutations();
  const accountMutations = useUserAccountMutations();

  return {
    addUser: addUserMutation.mutateAsync,
    ...statusMutations,
    ...accountMutations,
  };
};
